module.exports = __webpack_public_path__ + "static/media/1-_DSC0083.5b7956a2.jpg";